//Source: https://material-table.com/#/docs/features/editable

/* 
This version allows bulk edit to entire table, similar to spreadsheet.
Upon accpeting change, rows with changes are presented.
We can then loop through changes to update state and also parallely update DB.
This approach seems better, although I'll have to see how state changes goes,
and how it fares with respect to time.
*/
import React, {useContext, useState, useEffect} from "react";
import MaterialTable, { MTableToolbar } from 'material-table';
import Alert from '@material-ui/lab/Alert';
import LinkIcon from '@material-ui/icons/Link';
import { API, Auth } from 'aws-amplify';

import { HwContext } from "../contexts/HwContextProvider";


/** 
 * Create nested JSON hirarchy per DB schema
 *  returns unflattened data
 *  @param {string} data -  data to be unflattened
*/
function unflattenDbData(data) {
  let result = {}
  for (const item in data) {
    let objKeys = item.split('.')
    objKeys.reduce(function(reducer, currentItem, currentIdx) {
      return reducer[currentItem] || (
        reducer[currentItem] = isNaN(
          Number(objKeys[currentIdx + 1])
        ) ? (
          objKeys.length - 1 === currentIdx ? data[item] : {}
        ) : []
      )
    }, result)
  }
  //remove tableData key thats added by muitable lib
  if ("tableData" in result) {
    delete result["tableData"]
  }
  return result
}


export default function HWTable(props) {
  const [data, setData] = useState(props.rows);
  const [ hwState, hwDispatch] = useContext(HwContext);

  const rowsPerPage = 10;

  const columns = props.columns.map((column) => {
    return { ...column };
  });  

  function createDbData(config_dict_list) {
    const path = "hw_config/upload";
    API.post(
      process.env.REACT_APP_API_ENVIRONMENT, 
      path, {
        response: true,
        body: {
          config_dicts : config_dict_list,
          force: false,
          action : "upload_config",
        }
      })
    .then(response => {
      console.log(response);
      window.location.reload();
    })
    .catch(error => {
      console.log(error)
      console.log(error.response);
    });
  }

  /** 
   * Update existing DB data
   *  returns DDB response
   *  @param {string} config_dict_list -  data to be  uploaded to DDB
  */
  function updateDbData(config_dict_list) {
    const path = "hw_config/merge";
    API.post(
      process.env.REACT_APP_API_ENVIRONMENT, 
      path, {
        response: true,
        body: {
          config_dicts : config_dict_list,
          force: false,
          action : "upload_config",
        }
      })
    .then(response => {
      console.log(response);
      window.location.reload();
    })
    .catch(error => {
      console.log(error)
      console.log(error.response);
    });
  }


  /** 
   * delete existing DB data
   *  returns DDB response
   *  @param {string} config_dict -  data to be  deleted from DDB
  */
  function deleteDbRow(config_dict) {
    const path = "hw_config/delete";
    console.log("deleting data from db");
    API.post(
      process.env.REACT_APP_API_ENVIRONMENT, 
      path, {
        response: true,
        body: {
          action : "delete_config",
          hwconfig_names : config_dict,
        }
      })
    .then(response => {
      console.log(response);
      window.location.reload();
    })
    .catch(error => {
      console.log(error)
      console.log(error.response);
    });
  }


  /** 
   * new row add handler, calls createDbData
   *  returns nothing
   *  @param {string} newRowData -  new row data to be processed
  */
  function handleRowAdd(newRowData){
    const updatedData = unflattenDbData(newRowData);
    createDbData(updatedData);
    hwDispatch({ type: 'SET_DB_DATA_RECEIVED', dbDataReceived: false });
  }

  /** 
   * delete row handler, calls deleteDbRow
   *  returns nothing
   *  @param {string} rowData -  rowData to be processed
  */
  function handleRowDelete(rowData) {
    const updatedData = unflattenDbData(rowData);
    console.log(hwState.hwCurrentUser);
    setData([...data, updatedData]);
    deleteDbRow(updatedData['name']);
    hwDispatch({ type: 'SET_DB_DATA_RECEIVED', dbDataReceived: false });
  }

  /** 
   * row update handler, calls updateDbData
   *  returns nothing
   *  @param {string} rowData -  rowData to be processed
  */
  function handleRowUpdates(rowData) {
    console.log(rowData);
    const updatedData = [];
    for (const [key, value] of Object.entries(rowData)){
      const tmpData = unflattenDbData(rowData[key].newData);
      tmpData["_user"] = hwState.hwCurrentUser;
      updatedData.push(tmpData);
    }
    updateDbData(updatedData);
    hwDispatch({ type: 'SET_DB_DATA_RECEIVED', dbDataReceived: false });
  }

  const rowDataValidated = (newData) => {
    console.log(newData);
    const found = data.filter(obj => obj.name === newData.name);
    if (found.length  !== 0) {
      console.log("duplicate name found=>" + newData.name);
      hwDispatch({ 
        type: 'SET_MUI_TABLE_ALERT',
        tableAlertFlag: true,
        tableAlertMsg:  `duplicate name found ${newData.name}`,
      });
      return false;
    }
    hwDispatch({ 
      type: 'SET_MUI_TABLE_ALERT',
      tableAlertFlag: false,
      tableAlertMsg:  '',
    });
    return true;
  }

  useEffect(() => {
    Auth.currentAuthenticatedUser().then(
      (userData) => {
        console.log(userData);
        hwDispatch({ type: 'SET_HW_CURRENTUSER', hwCurrentUser: userData["username"] });
      }
    );
  }, []);
  
  
  return (
    <MaterialTable
      // title="Hardware Truth Table"
      columns={columns}
      data={data}
      actions={[
        {
          icon: LinkIcon,
          tooltip: 'Suggestions & Bug Report Quip Link',
          isFreeAction: true,
          // onClick: (event) => window.open(
          //   'https://quip-amazon.com/faMSAk1qb3nx/HwConfig-Suggestions','_blank','resizable=yes'
          // )
          onClick: (event) => window.open(
            'https://quip-amazon.com/4bTNAQYaJHVO/Hardware-Inventory-Project-HwConfig','_blank','resizable=yes'
          )
        }
      ]}
      components={{
        Toolbar: props => (
          <div>
            <MTableToolbar {...props} />
            { 
              hwState.tableAlertFlag && 
              <div style={{padding: '0px 10px'}}>
                <Alert severity="error"> <bold> {hwState.tableAlertMsg} </bold> </Alert>
              </div>
            }
          </div>
        ),
      }}
      options={{
        // filtering: true,
        // grouping: true,
        // paging: false,
        showTitle: false,
        exportButton: true,
        search: true,
        sorting: true,
        whiteSpace: 'nowrap',
        // actionsColumnIndex: -1,
        headerStyle: {
          backgroundColor: '#01579b',
          color: '#FFF',
          padding: '10px',
          position: 'sticky',
          top: 0
        },
        maxBodyHeight: '70vh',
        rowStyle: x => {
          if (x.tableData.id % 2) {
              return {backgroundColor: "#f2f2f2",fontSize: 12 }
          } else {
            return {fontSize: 12 }
           }
      },
      pageSize: rowsPerPage,
      pageSizeOptions: [5, 10, 20, { value: data.length, label: 'All' }],
      addRowPosition: 'first',
      }}
      editable={{
        onRowAdd: newData =>
          new Promise((resolve, reject) => {
              setTimeout(() => {
                  /* setData([...data, newData]); */
                  if (!rowDataValidated(newData)){
                    reject();
                  } else {
                    handleRowAdd(newData);
                    resolve();
                  }
                 
              }, 1000);
          }),
        onBulkUpdate: changes =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              handleRowUpdates(changes);
              resolve();
            }, 1000);
          }), 
        onRowDelete: oldData =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              handleRowDelete(oldData);
              resolve();
            }, 1000);
          }),     
      }}
    />
  );
}